<app-main-slider></app-main-slider>
<div class="home-container">
  <!-- Main Slider Section -->

  <!-- Centralized Brands and Product Widget Section -->
      <!-- Brands Section -->
      <div class="brands-container mb-10">
<!--
        <h3 class="text-2xl font-serif text-gold text-center mb-6">Our Prestigious Brands</h3>
-->
        <app-brands class="flex justify-center space-x-8 flex-wrap"></app-brands>
      </div>

      <!-- Featured Product Section -->
  <app-product-widget [products]="widgetProducts" [widgetTitle]="widgetTitle" class="full-width"></app-product-widget>
  <div class="promo-section">

    <app-promo></app-promo>
  </div>
  <app-product-widget [products]="widgetProducts" [widgetTitle]="widgetTitle" class="full-width"></app-product-widget>  <div class="promo-section">

</div>

</div>

